import { useQuery } from '@tanstack/react-query';
import { useState } from 'react';
import axiosInstance from '../../../constants/axiosInstance';
import { LogbookTemplate, useOCRStore } from '../store/ocrStore';

export const fetchLogbookTemplates = async ({ queryKey }: any): Promise<any[]> => {
    const [, searchQuery] = queryKey;
    try {
        const response = await axiosInstance().get<{ data: any }>(`/ocr/getListOfLogbookTemplateAutoComplete`, { params: { searchQuery } });
        return response.data.data;
    } catch (error) {
        throw error;
    }
};

export const useTemplateSelector = () => {
    const selectedTemplate = useOCRStore(state => state.selectedTemplate);
    const setSelectedTemplate = useOCRStore(state => state.setSelectedTemplate);
    const [inputValue, setInputValue] = useState('');

    const { data: templates = [], isLoading } = useQuery({
        queryKey: ['logbookTemplatesOptions', inputValue],
        queryFn: fetchLogbookTemplates,
        staleTime: 30000,
    });

    const handleTemplateChange = (event: React.SyntheticEvent, newValue: LogbookTemplate | null) => {
        setSelectedTemplate(newValue);
    };

    return {
        selectedTemplate,
        inputValue,
        setInputValue,
        templates,
        isLoading,
        handleTemplateChange,
    };
};
